import {useState} from 'react';
import AurDrawerNavigation from '../../../common/aur-drawer-navigation/AurDrawerNavigation';

const DrawerNavigation = () => {
  const [departmentDrawerNavigationState, setDepartmentDrawerNavigationState] =
    useState({currentItemOrder: 1, totalItemCount: 10});
  const departmentDrawerNavigatonHandler = (itemOrder: number) => {
    // API call to get required project here
    setDepartmentDrawerNavigationState((pv) => {
      return {...pv, currentItemOrder: itemOrder};
    });
  };
  return (
    <div>
      <h2>Drawer or Flyout navigation</h2>
      <AurDrawerNavigation
        currentItemOrder={departmentDrawerNavigationState.currentItemOrder}
        totalItemCount={departmentDrawerNavigationState.totalItemCount}
        previousButtonAriaLabel="Previous item"
        nextButtonAriaLabel="Next item"
        navigationClickHandler={departmentDrawerNavigatonHandler}
      />
    </div>
  );
};

export default DrawerNavigation;
